import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class Go2MarketDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Go2Market' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                
                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--4"  data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">GO2MARKET</h2>
                                    <p>Gestión grupal de listas de la compra en tiempo real. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>Go2Market</h2>
                                        <p className="subtitle">Aplicación móvil para la gestión de la lista de la compra.</p>
                                        <p>La aplicación permite realizar diferentes grupos de personas que van a poder gestionar diferentes listas de la compra en tiempo real.</p>
                                        <p> La aplicación contiene un sistema de inteligencia artificial que detecta la frase introducida por el usuario y le establece un icono y una seccion del supermercado y un sistema "Text to Speech" para poder rellenar las listas de la compra por voz, vista de cambios en la lista de la compra en tiempo real, sistema de notificaciones push, etc.</p>
                                        <p>Proyecto personal desarrollado en 2019, actualmente cuenta con más de 65.000 usuarios mensuales.</p>

                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Framework Frontend</span>
                                                <h4>Flutter (Móvil)</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Framework Backend</span>
                                                <h4>Node.js (Firebase)</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Lenguajes</span>
                                                <h4>Dart & Javascript</h4>
                                            </div>
                                        </div>

                                        <div className="portfolio-share-link mt--20 pb--70 pb_sm--40">
                                            <div className="header-btn">
                                                <a className="rn-btn" href="https://play.google.com/store/apps/details?id=com.danieto99.go2market&hl=es&gl=ES">
                                                    <span>Ver app en Play Store</span>
                                                </a>
                                            </div>
                                            <div className="header-btn mt--15 ">
                                                <a className="rn-btn" href="https://apps.apple.com/es/app/lista-de-la-compra-go2market/id1546259413">
                                                    <span>Ver app en App Store</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />  


            </React.Fragment>
        )
    }
}
export default Go2MarketDetails;
